import React, { useState } from 'react'

// stripe
import {
    useElements,
    useStripe,

    CardNumberElement,
    CardExpiryElement,
    CardCvcElement
} from '@stripe/react-stripe-js';

export default function PaymentContainer(props) {
    // props
    const {
        totalAmount,
        setStripeTokenRecieved,
    } = props

    // consts
    const elements = useElements()
    const stripe = useStripe()

    // states
    const [buttonLoading, setButtonLoading] = useState(false)
    const [buttonDisable, setButtonDisable] = useState(false)

    const [errorMessage, setErrorMessage] = useState(false)

    // on form submit
    const handleFormSubmit = async ev => {
        ev.preventDefault()

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setErrorMessage("") // emptying error message

        // button loading
        setButtonLoading(true)
        setButtonDisable(true)

        const card = elements.getElement(CardNumberElement);
        const result = await stripe.createToken(card);

        if (result.error) {
            setErrorMessage(result.error.message) // setting error message

            // button loading
            setButtonLoading(false)
            setButtonDisable(false)
        } else {
            setErrorMessage("") // emptying error message

            setStripeTokenRecieved(result.token.id)

            // button loading
            setButtonLoading(false)
            setButtonDisable(false)
        }
    }

    return (
        <React.Fragment>
            <form onSubmit={handleFormSubmit}>
                <div className="form-main d-flex flex-wrap">
                    <div className="st-form w-100">
                        <label>Card Number</label>
                        <CardNumberElement />
                    </div>

                    <div className="st-form lt">
                        <label>Expiry Date</label>
                        <CardExpiryElement />
                    </div>
                    <div className="st-form rt">
                        <label>CVV</label>
                        <CardCvcElement />
                    </div>
                </div>
                {/* <CardElement
                    id="card-element-main"
                    options={{
                        hidePostalCode: true,
                        classes: {
                            base: "payment-card-element form-control"
                        },
                    }}
                /> */}

                {
                    errorMessage?.length ? (
                        <p className="text-danger mb-0" style={{}}>{errorMessage}</p>
                    ) : null
                }

                {/* submit button */}
                <div className="btns w-100 pt-3">
                    <button
                        type="submit"
                        className="st-btn st-btn-primary"
                        disabled={(!stripe) || (!elements) || buttonDisable}
                        style={{ width: 200 }}
                    >
                        {
                            buttonLoading ? (
                                "Loading..."
                            ) : (
                                <React.Fragment>
                                    Pay {totalAmount ?? 0}
                                </React.Fragment>
                            )
                        }
                    </button>
                </div>
            </form>
        </React.Fragment>
    )
}